import { takeLatest, call, put, all } from "redux-saga/effects";
import {
  INITIATE_STARTUP_CREATION,
  INITIATE_PUBLISH_NOW,
  INITIATE_PUBLISH_PAGE_LAYOUT,
  INITIATE_PUBLISH_MENU_LAYOUT,
  STARTUP_CREATION_SUCCESS,
  STARTUP_CREATION_FAILURE,
  PUBLISH_NOW_SUCCESS,
  PUBLISH_NOW_FAILURE,
} from "../actions/types";
import {
  startupCreationSuccess,
  startupCreationFailure,
  publishNowSuccess,
  publishNowFailure,
  publishPageLayoutSuccess,
  publishPageLayoutFailure,
  publishMenuLayoutSuccess,
  publishMenuLayoutFailure,
} from "../actions/startupAppActions";
import {
  createStartupApi,
  publishStartupApi,
  publishPageLayoutApi,
  publishMenuLayoutApi,
} from "../apis/startupApi"; // Import the API functions

// Saga to handle startup creation
function* initiateStartupCreation(action) {
  try {
    // console.log(
    //   `PMM - SF - saga - initiateStartupCreation - action is: ${JSON.stringify(
    //     action
    //   )}`
    // );
    // Call the createStartupApi with the startup name from the action payload
    const response = yield call(publishPageLayoutApi, action.payload);
    // Dispatch the success action with the response message
    yield put(startupCreationSuccess(response.message));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(startupCreationFailure(error.message));
  }
}

// Saga to handle publishing process for full startup
function* initiatePublish(action) {
  try {
    // console.log(
    //   `PMM - SF - saga - initiatePublish - action is: ${JSON.stringify(action)}`
    // );
    // Call the publishStartupApi with the startup name from the action payload
    const response = yield call(publishStartupApi, action.payload);
    // Dispatch the success action with the response message
    yield put(publishNowSuccess(response.message));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(publishNowFailure(error.message));
  }
}

// Saga to handle publishing current page layout
function* initiatePublishPageLayout(action) {
  // console.log(`PMM - SF - saga - initiatePublishPageLayout - here too`);
  try {
    const successMessage = "Publish Page Layout succeeded";
    // console.log(
    //   `PMM - SF - saga - initiatePublish - action is: ${JSON.stringify(
    //     successMessage
    //   )}`
    // );

    // Call the publishPageLayoutApi with the startup name and page layout data
    const response = yield call(publishPageLayoutApi, action.payload);
    console.log(
      `PMM - SF - startupSaga.js - initiatePublish outgoing - action is: ${JSON.stringify(
        action
      )}`
    );
    console.log(
      `PMM - SF - startupSaga.js - initiatePublish - response is: ${JSON.stringify(
        response
      )}`
    );
    // Dispatch the success action with the response message
    yield put(publishPageLayoutSuccess(successMessage));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(publishPageLayoutFailure(error.message));
  }
}

// Saga to handle publishing current page layout
function* initiatePublishMenuLayout(action) {
  try {
    console.log(
      `PMM - SF - saga - initiatePublish - action is: ${JSON.stringify(action)}`
    );

    // Call the publishPageLayoutApi with the startup name and page layout data
    const response = yield call(publishMenuLayoutApi, action.payload);
    // console.log(
    //   `PMM - SF - saga - initiatePublish - response is: ${JSON.stringify(
    //     response
    //   )}`
    // );
    const successMessage = response?.publishMenuLayout?.message;

    // Dispatch the success action with the response message
    yield put(publishMenuLayoutSuccess(successMessage));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(publishMenuLayoutFailure(error.message));
  }
}

// Watcher saga for startup creation
function* watchInitiateStartupCreation() {
  yield takeLatest(INITIATE_STARTUP_CREATION, initiateStartupCreation);
}

// Watcher saga for publishing
function* watchInitiatePublish() {
  yield takeLatest(INITIATE_PUBLISH_NOW, initiatePublish);
}

// Watcher saga for publishing page layout
function* watchInitiatePublishPageLayout() {
  // console.log(`PMM - SF - saga - watchInitiatePublishPageLayout - here`);
  yield takeLatest(INITIATE_PUBLISH_PAGE_LAYOUT, initiatePublishPageLayout);
}

// Watcher saga for publishing menu layout
function* watchInitiatePublishMenuLayout() {
  // console.log(`PMM - SF - saga - watchInitiatePublishMenuLayout - here`);
  yield takeLatest(INITIATE_PUBLISH_MENU_LAYOUT, initiatePublishMenuLayout);
}

// Root saga that exports all watchers
export default function* startupSaga() {
  yield all([
    watchInitiateStartupCreation(),
    watchInitiatePublish(),
    watchInitiatePublishPageLayout(),
    watchInitiatePublishMenuLayout(),
  ]);
}
